export const LabelText = {
  ADD_BUTTON: 'Place order',
  PLACE_ORDER_INFORMATION:
    'Once we receive payment within 30 days of placing your order and verify your business information, your gift cards will be sent automatically'
};
